import {AxiosConfig} from "./AxiosConfig/AxiosConfig";
import { IGpt } from "Interfaces/Gpt";

const getAllGpt = async (): Promise<Array<IGpt>> => {
    return new Promise<Array<IGpt>>((resolve) => {
        return AxiosConfig.instance.get("/gpt").then(res => {
            const gpts: Array<IGpt> = res.data;
            return resolve(gpts);
        }).catch(error => {
            console.error(error);
            resolve(new Array<IGpt>());
        });
    });
}

const GptApi = {
    getAllGpt, 
}

export default GptApi;